import { irisEnabled, irisRequest, loadSession } from '../auth/iris';
import axios from './axios';

const login = (userLogin, password, recaptchaValue) =>
  axios({
    method: 'post',
    url: '/v1/users/login',
    skipAuthRefresh: true,
    data: {
      login: userLogin,
      password,
      recaptchaValue
    }
  });

const logout = () =>
  axios({
    method: 'post',
    url: '/v1/users/logout'
  });

const loadUser = userId =>
  axios({
    method: 'get',
    url: `/v1/users/${userId}`
  });

const updateUser = (userId, values) => {
  if (irisEnabled && Object.keys(values).some(key => /password/i.test(key)))
    return Promise.reject(new Error('Use the credential endpoint'));
  return axios({
    method: 'put',
    url: `/v1/users/${userId}`,
    data: values
  });
};

const resetPassword = values =>
  irisEnabled
    ? irisRequest('/auth/credentials/password', 'POST', {
        current_password: values.current_password || values.prev_password || values.old_password,
        new_password: values.new_password || values.password
      }).then(data => ({ data }))
    : axios({
        method: 'post',
        url: '/v1/users/set-password',
        data: values
      });

const requestResetPassword = (resetLogin, recaptchaValue) =>
  axios({
    method: 'post',
    url: '/v1/users/reset-password',
    data: {
      login: resetLogin,
      recaptchaValue
    }
  });

const loadUserList = organizationId =>
  axios({
    method: 'get',
    url: '/v1/users',
    params: {
      organization_id: organizationId
    }
  });

const deleteUser = (userId, organizationId) =>
  axios({
    method: 'delete',
    url: `/v1/users/${userId}`,
    params: {
      organization_id: organizationId
    }
  });

const inviteUser = values =>
  irisEnabled
    ? loadSession()
        .then(session =>
          irisRequest('/auth/invitations', 'POST', {
            event_id: crypto.randomUUID(),
            organization_id: session.organization_id,
            email: values.email,
            first_name: values.first_name || '',
            role:
              { 'urn:roles:manager': 'customer-admin', 'urn:roles:operator': 'operator' }[values.role] || values.role
          })
        )
        .then(data => ({ data }))
    : axios({
        method: 'post',
        url: '/v1/users/invite',
        data: values
      });

export {
  login,
  logout,
  loadUser,
  updateUser,
  resetPassword,
  requestResetPassword,
  loadUserList,
  deleteUser,
  inviteUser
};
